module.exports = __webpack_public_path__ + "img/avatar-ai.d2f2bc22.svg";